/*
 * File: /src/router/routes/contacts.js
 * Created Date: Tuesday May 21st 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 21st May 2019 11:55:29 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const ContactsAdd = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactAdd.vue'
  );
const ContactsView = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactView.vue'
  );
const ContactsVerified = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactVerified.vue'
  );
const ContactsList = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactList.vue'
  );
const ContactsImport = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactImport.vue'
  );
const ContactsImportStatus = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactImportStatus.vue'
  );
const ContactsSearch = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactSearch.vue'
  );

// TODO: this could be under a different webpack chunk, but with the conversion to vite coming up, no need to carve out new ones.
const CustomFields = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/CustomFields/CustomFields.vue'
  );
const ContactMerge = () =>
  import(
    /* webpackChunkName: "Contacts" */ 'src/components/Dashboard/Views/Contacts/ContactMerge.vue'
  );

export const contactsRoutes = [
  {
    path: 'contacts/search',
    name: 'Search',
    component: ContactsSearch,
  },
  {
    path: 'contacts/verified',
    name: 'Emails Verified',
    component: ContactsVerified,
  },
  {
    path: 'contacts/add/:groupId?',
    name: 'New Contact',
    component: ContactsAdd,
  },
  {
    path: 'contacts/list/:pageId?',
    name: 'Contacts',
    component: ContactsList,
    props: route => ({
      // Group and tag ids are either a string if one, or an array if more
      // than one. vue-router is supposed to send an array always but it does not
      queryGroups: route.query.groups
        ? (Array.isArray(route.query.groups)
          ? route.query.groups
          : [route.query.groups]
        ).map(g => parseInt(g)).filter(g => !Number.isNaN(g))
        : undefined,
      queryTags: route.query.tags
        ? (Array.isArray(route.query.tags)
          ? route.query.tags
          : [route.query.tags]
        ).map(t => parseInt(t)).filter(t => !Number.isNaN(t))
        : undefined,
      querySources: route.query.filterSource
        ? (Array.isArray(route.query.filterSource)
          ? route.query.filterSource
          : [route.query.filterSource])
        : undefined,
      queryOwnerId: (Number.parseInt(route.query.filterOwner)) || undefined,
      queryContains: route.query.filterContains,
      queryFilterType: route.query.filterType,
      // The date range is always sent as a pair
      queryDateStart: Array.isArray(route.query.filterDate)
        ? route.query.filterDate[0]
        : undefined,
      queryDateEnd: Array.isArray(route.query.filterDate)
        ? route.query.filterDate[1]
        : undefined,
    }),
  },
  {
    path: 'contacts/view/:id',
    name: 'Viewing Contact',
    component: ContactsView,
    props: route => ({
      contactId: parseInt(route.params.id),
    }),
  },
  {
    path: 'contacts/import',
    name: 'Import',
    component: ContactsImport,
  },
  {
    path: 'contacts/import-status',
    name: 'Import Status',
    component: ContactsImportStatus,
  },
  {
    path: 'contacts/fields',
    name: 'Custom Fields',
    component: CustomFields,
  },
  {
    path: 'contacts/merge',
    name: 'Merge Contacts',
    component: ContactMerge,
    props: (route) => ({
      id1: route.query.id1,
      id2: route.query.id2,
    }),
  },
];
